import script from "./ValidadorFranjaHoraria.vue?vue&type=script&lang=ts"
export * from "./ValidadorFranjaHoraria.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__